import React from 'react';
import {PaymentRegisterComponent} from '../../components';

// Todo 支払い部分の統合
export const PaymentRegister: React.FC = () => {
  return <PaymentRegisterComponent />;
};
